import { QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from '@/components/error-boundary';
import { SessionProvider } from '@/hooks/use-session';
import { queryClient } from '@/lib/query-client';
import { Router } from '@/router';

/**
 * SessionProvider sits inside QueryClientProvider because it is built on
 * useQuery, and inside ErrorBoundary so a crash while resolving the session
 * still renders something.
 */
export const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <Router />
      </SessionProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);
